import { Box, Typography } from '@mui/material'

export const demandHints = [
  {
    partner: '*',
    element: () => (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          pt: '0.5em',
          pb: '0.5em'
          // backgroundColor: '#FADF8E',
          // height: '8em'
        }}>
        <Box sx={{ ml: '0.5em', mr: '0.5em' }}>
          <Box sx={{ alignSelf: 'left' }}>
            <Typography variant="inherit">
              計測したDMが最大DMを超えると契約電力が更新され電気料金が上がります。
            </Typography>
            <Typography variant="inherit">
              一度超えると1年間はその値より契約電力は下がりません。
            </Typography>
            <Typography variant="inherit">
              例えば、5kW超えた場合、年10万円超のコスト増となります。
            </Typography>
            <Typography variant="inherit">※5kW×1,800円×12か月</Typography>
          </Box>
        </Box>
      </Box>
    )
  }
]
